import room_user_status from "./room_user_status";
import { roundstates } from "./enums";
import { riverDamageLevel, maxRounds } from "./game";
import playerState from "./playerstate";
import property, { farm1, farm2, getBuyCost, getDefaultRevenue, getSellCost, marae, ownedPropertyValue, townsFolkHouseBlue, townsFolkHouseOrange } from "./property";
import propertyState from "./propertyState";

export default class room_user {

    _id: string;
    username: string;
    realname: string;
    greeting: string;
    intro: string;

    fill: string;
    filter: string;
    status: room_user_status | null = new room_user_status();
    startProperty: property;

    analyticsId: string;

    constructor(id: string, fill: string, analyticsId: string, startProperty: property, filter: string) {
        this._id = id;

        const relativeID = (parseInt(id, 10) + 1);

        this.username = 'Avatar_' + relativeID + '_title';
        this.realname = 'Avatar_' + relativeID + '_name';
        this.greeting = 'Avatar_' + relativeID + '_greeting';
        this.intro = 'Avatar_' + relativeID + '_intro';
        this.analyticsId = analyticsId;

        this.fill = fill;
        this.startProperty = startProperty;
        this.filter = filter;
    }

    generatePlayerState(): playerState {

        const result: playerState = {
            isOverdue: false,
            bankBalance: 0,
            round: 0,
            roundState: roundstates.ChooseOption, //At the start of the game, the player chooses to stay or sell
            properties: [],
            stopBank: false,

            stopBankDestroyed: false,
            natureBasedSeaDestroyed: false,
            cowshedDestroyed: false,
            seaWallDestroyedHeight: 0,

            natureBasedState: 0,
            natureBasedSeaSolution: false,
            isMakingNatureBasedSolution: false,
            livedInProperty: "",
            playerRPC: {},
            lastSeen: new Date().getTime(),
            roundActions: new Array(maxRounds + 1),
            display_income: 0,
            display_rent: 0,
            display_repair: 0,
            seaWallHeight: 0,
            seaWallRound: 0,
            roundAnalytics: null,

            round_bankbalance: new Array(maxRounds + 1),
            round_property: new Array(maxRounds + 1),
            round_propertyvalue: new Array(maxRounds + 1),
        }
        
        buyProperty(result, this.startProperty, "", true, false);

        //Analytics setup
        result.round_bankbalance[0] = getDefaultRevenue(this.startProperty);
        result.round_property[0] = this.startProperty.key;
        result.round_propertyvalue[0] = ownedPropertyValue(result);

        return result;

    }
}

export function buyProperty(state: playerState, property: property | null, soldProperty: string, moveInto: boolean, subtractCostOfNewHouse: boolean = true) {


    if (property && subtractCostOfNewHouse) {
        //Subtract the cost of the new home
        state.bankBalance -= getBuyCost(property);
    }

    //We're moving OUT of a place we already own
    if (soldProperty) {

        //Flag that we're no longer due for repair
        state.isOverdue = false;

        let deleteIndex = 0;
        for (let i = 0; i < state.properties.length; i++) {
            if (state.properties[i].property == soldProperty) {

                let oldPropertyValue = getSellCost(state, state.properties[i]);

                //Add the cost of the old home
                if (oldPropertyValue) {
                    state.bankBalance += oldPropertyValue;
                }

                deleteIndex = i;
                break;
            }
        }
        state.properties.splice(deleteIndex, 1);
    }

    //We're not actually buying a new property, only selling
    if (!property) {
        return;
    }

    //The base property state
    const propertyState: propertyState = {
        property: property.key,
        propertyPartStates: [],
        damageLevel: riverDamageLevel.none,
        hasDrainagePump: false,
    };

    //Set a property state for EVERY part
    let autoRaiseFloor = state.isMakingNatureBasedSolution;

    for (let i = 0; i < property.property_parts.length; i++) {

        propertyState.propertyPartStates.push({

            hasRaisedFloor: [autoRaiseFloor, autoRaiseFloor, autoRaiseFloor],
            movePosition: 0,
            repairCost: 0,
            isMoving: false,

            //Part is only automatically built if the build cost is 0
            //            isBuilt: (property.property_parts[i].buildCost == 0)
        });

    }

    state.properties.push(propertyState);

    if (moveInto) {
        state.livedInProperty = property.key;
    }

}

export const users: room_user[] = [
    new room_user("0", "#e46dbd", "town1", townsFolkHouseOrange, "invert(58%) sepia(82%) saturate(710%) hue-rotate(285deg) brightness(95%) contrast(87%)"),
    new room_user("1", "#5dc4e5", "town2", townsFolkHouseBlue, "brightness(0) saturate(100%) invert(73%) sepia(34%) saturate(817%) hue-rotate(160deg) brightness(94%) contrast(91%)"),
    new room_user("2", "#f1a738", "farm1", farm1, "brightness(0) saturate(100%) invert(87%) sepia(41%) saturate(2831%) hue-rotate(330deg) brightness(97%) contrast(95%)"),
    new room_user("3", "#4e419b", "farm2", farm2, "brightness(0) saturate(100%) invert(28%) sepia(22%) saturate(2004%) hue-rotate(212deg) brightness(94%) contrast(96%)"),
    new room_user("4", "#b2cd30", "marae", marae, "brightness(0) saturate(100%) invert(82%) sepia(15%) saturate(1908%) hue-rotate(22deg) brightness(93%) contrast(94%)"),
]

export const iconClasses: string[] = [
    "townsperson1-game-piece",
    "townsperson2-game-piece",
    "farmer1-game-piece",
    "farmer2-game-piece",
    "komatua-game-piece",
]
